export default __webpack_public_path__ + "static/elementmarket-ddd944fd6d7a718020e6b180b1b07891.jpeg";